// Processing Station - Initial order processing after payment
import React from 'react';
import { ClipboardList } from 'lucide-react';
import BaseStationScreen from '../components/BaseStationScreen';

const ProcessingStation: React.FC = () => {
  return (
    <BaseStationScreen
      stationId="processing"
      stationName="Processing"
      stationIcon={<ClipboardList className="w-6 h-6" />}
      stationColor="#3B82F6"
      showAdvanceButton={true}
      showCustomerContact={false}
      showDeliveryInfo={false}
    />
  );
};

export default ProcessingStation;
